import { useMemo } from "react";
import useData from "./useData";
import useMetadata from "./useMetadata";
import { EXPERIMENT, WIDGET_TYPE, WIDGET_VERSION } from "../conf";

const useExperience = () => {
	const metadata = useMetadata();

	const { runningExperiments = [] } = useData();

	const { active_widget_version, active_widget_type } = metadata;

	const shouldIncreaseImpressions = useMemo(
		() => !!runningExperiments?.[EXPERIMENT.FEED_INCREASE_IMPRESSIONS],
		[runningExperiments]
	);

	const isNurtureV1 =
		active_widget_type === WIDGET_TYPE.LEAD_GEN &&
		active_widget_version === WIDGET_VERSION[WIDGET_TYPE.LEAD_GEN][1];

	return {
		activeWidgetType: active_widget_type,
		activeWidgetVersion: active_widget_version,
		runningExperiments,
		shouldIncreaseImpressions,
		isNurtureV1,
	};
};

export default useExperience;
